import { deleteFromDB, removeItemById } from "@";

// Hook for deleting an item
export function useDelete(data, setData, from) {
  const deleteHandler = async (id) => {
    try {
      const res = await deleteFromDB(id, from);
      if (res) setData(removeItemById(data, id));
    } catch (error) {}
  };

  return { deleteHandler };
}
